import { render, staticRenderFns } from "./PanelDetailInfo.vue?vue&type=template&id=6d0799d4&scoped=true&"
import script from "./PanelDetailInfo.vue?vue&type=script&lang=js&"
export * from "./PanelDetailInfo.vue?vue&type=script&lang=js&"
import style0 from "./PanelDetailInfo.vue?vue&type=style&index=0&id=6d0799d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0799d4",
  null
  
)

export default component.exports